import { useEffect } from "react";

import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";
import { useGetPressListFilterData } from "@PressListContainer/hooks/useGetPressListFilterData";
import { pressListApis } from "@services/pressList.service";
import { usePressListFilterState } from "@stores/pressList";

import { queryClient } from "../../api/queryClient";

import type {
  FilteringData,
  PostPressListFilterResponse,
} from "@interface/pressList.interface";

export const usePressListFilterQuery = (
  options?: UseQueryOptions<
    PostPressListFilterResponse,
    unknown,
    PostPressListFilterResponse,
    [string, FilteringData]
  >,
) => {
  const filteringData = useGetPressListFilterData();
  const [, setPressListFilter] = usePressListFilterState();
  const query = useSuspenseQuery({
    queryKey: [QUERY_KEYS.pressListFilter, filteringData],
    queryFn: async () => {
      const response = await pressListApis.post(filteringData);
      return response;
    },
    staleTime: 0,
    refetchInterval: 2000,
    ...options,
  });

  useEffect(() => {
    setPressListFilter((prev) => ({
      ...prev,
      maxPage: query.data.totalPage,
      pressListDataTotal: query.data.totalCount,
    }));
  }, [query.data.totalCount, query.data.totalPage, setPressListFilter]);

  return query;
};

export const invalidatePressListFilterQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: [QUERY_KEYS.pressListFilter],
  });
};
